export const REGULATIONS = {
  natura2000: [
    {
      id: 'n2k-vergunning',
      title: 'Vergunningsplicht Natura 2000',
      summary:
        'Voor activiteiten die significante gevolgen kunnen hebben voor een Natura 2000-gebied is een vergunning vereist op grond van de Wet natuurbescherming (art. 2.7).',
      severity: 'high',
      source: 'Wet natuurbescherming',
      link: 'https://wetten.overheid.nl/BWBR0037552',
    },
    {
      id: 'n2k-stikstof',
      title: 'Stikstofbeoordeling',
      summary:
        'Stikstofdepositie op Natura 2000-gebieden moet worden beoordeeld. Bij overschrijding van de kritische depositiewaarde (KDW) is een passende beoordeling nodig.',
      severity: 'high',
      source: 'Bij12 / RIVM',
      link: 'https://www.bij12.nl/onderwerpen/stikstof/',
    },
    {
      id: 'n2k-gewas',
      title: 'Beperking gewasbeschermingsmiddelen',
      summary:
        'Nabij Natura 2000-gebieden gelden aanvullende beperkingen voor het gebruik van gewasbeschermingsmiddelen ter bescherming van kwetsbare habitats.',
      severity: 'medium',
      source: 'CTGB',
      link: 'https://www.ctgb.nl',
    },
  ],
  buffer: [
    {
      id: 'buf-teeltvrij',
      title: 'Teeltvrije zone',
      summary:
        'Langs watergangen geldt een teeltvrije zone van minimaal 50 cm (bouwland) of 25 cm (grasland). In deze zone mag niet worden geteeld of bemest.',
      severity: 'medium',
      source: 'RVO',
      link: 'https://www.rvo.nl/onderwerpen/teeltvrije-zone',
    },
    {
      id: 'buf-drift',
      title: 'Driftreductie verplichting',
      summary:
        'Bij het spuiten van gewasbeschermingsmiddelen langs watervoerende sloten is driftreductie van minimaal 75% verplicht. Gebruik van driftreducerende doppen (DRT) is vereist.',
      severity: 'medium',
      source: 'Helpdesk Water',
      link: 'https://www.helpdeskwater.nl',
    },
    {
      id: 'buf-bemesting',
      title: 'Bemestingsvrije zone',
      summary:
        'Binnen 5 meter van de insteek van een watergang mag geen dierlijke mest of kunstmest worden toegepast (Activiteitenbesluit milieubeheer).',
      severity: 'low',
      source: 'RVO',
      link: 'https://www.rvo.nl/onderwerpen/mest',
    },
  ],
  water: [
    {
      id: 'water-onderhoud',
      title: 'Onderhoudsverplichting watergang',
      summary:
        'Perceeleigenaren langs watergangen zijn verantwoordelijk voor het onderhoud van de oever en het schoonhouden van de watergang conform de Keur van het waterschap.',
      severity: 'low',
      source: 'Unie van Waterschappen',
      link: 'https://www.uvw.nl',
    },
  ],
};

export const SEVERITY_LABELS = {
  high: 'Hoog',
  medium: 'Middel',
  low: 'Laag',
};
